// extracted by mini-css-extract-plugin
module.exports = {"folder":"CategoryPreloader_folder__1lyVp","info":"CategoryPreloader_info__43Vw3"};